"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JoinLauncherContextConsumer = exports.JoinLauncherContextProvider = void 0;
const React = require("react");
const context = React.createContext({});
exports.JoinLauncherContextProvider = context.Provider;
exports.JoinLauncherContextConsumer = context.Consumer;
